

export default () => {

    return (
        <section className="banner compressed">
            <div className="background">
                <video style={{ opacity: '0.4' }} loading="lazy" aria-label="Banner con el logo de sanolivar" src="./assets/videos/logo-animated.mp4" autoPlay muted playsInline loop />
            </div>
            <h1 className="logo">Nosotros</h1>
            <p>Somos una empresa colombiana con sólidos valores, liderazgo y creatividad, dedicada a construir soluciones basadas en el conocimiento, la innovación y tecnología de vanguardia.</p>
        </section>
    )
}